module.exports = __webpack_public_path__ + "img/sfq7.6156064c.png";